import React from 'react';
import { usePortal } from '../../contexts/PortalContext';
import type { Deliverable } from '../../types/portal';
import { BUTTON_QUIET } from './adminStyles';
export function VersionHistory({
  deliverable
}: {
  deliverable: Deliverable;
}) {
  const {
    toggleVersionVisibility,
    notify
  } = usePortal();
  return <section aria-labelledby={`versions-${deliverable.id}`} className="mt-12" data-id="element-390" data-mp="1q5icadf43x4p">
      <h4 id={`versions-${deliverable.id}`} className="label border-b border-ruleDark pb-4 text-paper/40" data-id="element-391" data-mp="1c6sip7ri4fl3">
        Version History
      </h4>

      <ul className="m-0 list-none p-0" data-id="element-392" data-mp="1h3ivnm80ev2a">
        <li className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-3 border-b border-ruleDark py-5" data-id="element-393" data-mp="128uvmnldoou2">
          <span className="flex items-baseline gap-5" data-id="element-394" data-mp="178h4kku6bix2">
            <span className="font-display text-2xl leading-none" data-id="element-395" data-mp="2wmci07a1rfni">
              {deliverable.version || '—'}
            </span>
            <span className="label border border-paper bg-paper px-2.5 py-1.5 text-ink" data-id="element-396" data-mp="31lp4us0x4mq3">
              Current Version
            </span>
          </span>
          <span className="label-sm text-paper/40" data-id="element-397" data-mp="2b2xz808d6bzb">
            {deliverable.status}
            {deliverable.versionDate !== '—' ? ` · ${deliverable.versionDate}` : ''}
          </span>
        </li>

        {deliverable.versions.map(entry => <li key={entry.id} className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-3 border-b border-ruleDark py-5" data-id="element-398" data-mp="2fvhcew35353l">
            <span className="flex items-baseline gap-5" data-id="element-399" data-mp="1n71zqg7hcyvf">
              <span className="font-display text-2xl leading-none text-paper/70" data-id="element-400" data-mp="1n8mua5tsohta">
                {entry.version}
              </span>
              <span className="label-sm text-paper/40" data-id="element-401" data-mp="1x59cemuqkurm">
                {entry.label} · {entry.date}
                {entry.changeCount ? ` · ${entry.changeCount} change${entry.changeCount === 1 ? '' : 's'}` : ''}
              </span>
            </span>

            <span className="flex items-center gap-6" data-id="element-402" data-mp="38mr4uq6va7yu">
              <button type="button" onClick={() => notify(entry.driveUrl ? `Simulated · would open ${entry.version} in Google Drive` : `Simulated · ${entry.version} preview`)} className={BUTTON_QUIET} data-id="element-403" data-mp="258phl7hck61v">
                Open
              </button>
              <button type="button" onClick={() => {
            toggleVersionVisibility(deliverable.id, entry.id);
            notify(entry.visibleToClient ? `${entry.version} hidden from client` : `${entry.version} shown to client under Previous Versions`);
          }} aria-pressed={entry.visibleToClient} className={['label border px-3 py-2 transition-colors duration-150 ease-out', entry.visibleToClient ? 'border-paper bg-paper text-ink' : 'border-paper/30 text-paper/40 hover:border-paper/60'].join(' ')} data-id="element-404" data-mp="1mgwprge0kqvq">
                {entry.visibleToClient ? 'Visible to client' : 'Internal'}
              </button>
            </span>
          </li>)}

        {deliverable.versions.length === 0 && <li className="py-5 font-display text-lg text-paper/40" data-id="element-405" data-mp="hday9w04j00i">No earlier versions yet.</li>}
      </ul>
    </section>;
}